import {Edge} from 'app/domain/edge';

export function filterByDeviceModel(presets: Edge.TeamPreset[], model: string) {
  return presets.filter((devicePreset) => devicePreset.device === model);
}
